import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './custom.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { initializeFirebase } from './push-notification';
import firebase from 'firebase';

// We listen to the resize event
window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});
// We execute the same script as before
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

ReactDOM.render(<App />, document.getElementById('root'));

initializeFirebase();

// firebase 8 gooit hier "Missing App configuration value" (enkel messagingSenderId geconfigureerd);
// zonder try/catch zou serviceWorker.register() hieronder nooit uitgevoerd worden.
try {
    const messaging = firebase.messaging();

    messaging.onTokenRefresh(function() {
        messaging.getToken().then(function(refreshedToken) {
            console.log('Token refreshed: '+refreshedToken);
        }).catch(function(err) {
            console.error('Unable to retrieve refreshed token: '+err);
        });
    });
} catch (err) {
    console.warn('Firebase messaging niet beschikbaar: '+err);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
